import classNames from 'classnames';

import Grid from '~components/_layout/Grid/Grid';
import { prefixImageLink } from '~globals/common';

type Props = {
    adjustgridheight?: boolean;
    bgcolor?: string;
    heighttablet?: string;
    heightdesktop?: string;
    colspanmobile?: string;
    colspantablet?: string;
    colspandesktop?: string;
    heroimagemobile?: string;
    heroimagetablet?: string;
    heroimagedesktop?: string;
    heroimagexl?: string;
    heroimagexxl?: string;
    isleft?: boolean;
    iscolor?: boolean;
    isfullwidth?: boolean;
    iscathero?: boolean;
    hasBgOverlay?: boolean;
};

const Hero = ({
    adjustgridheight,
    bgcolor,
    children,
    heighttablet = 'md:min-h-[329px]',
    heightdesktop = 'lg:min-h-[514px]',
    colspanmobile = '4',
    colspantablet = '4',
    colspandesktop = '6',
    heroimagemobile,
    heroimagetablet,
    heroimagedesktop,
    heroimagexl,
    heroimagexxl,
    isleft = true,
    iscolor = false,
    isfullwidth = true,
    iscathero = false,
    hasBgOverlay = false,
}: React.PropsWithChildren<Props>) => {
    const modMobileImage = prefixImageLink(heroimagemobile as string);
    const modTabletImage = prefixImageLink(heroimagetablet as string);
    const modDesktopImage = prefixImageLink(heroimagedesktop as string);
    const modDesktopXLImage = prefixImageLink(heroimagexl as string);
    const modDesktopXXLImage = prefixImageLink(heroimagexxl as string);

    return (
        <section
            className={classNames(
                'relative w-full flex items-center overflow-hidden',
                heighttablet,
                iscathero ? 'lg:min-h-[360px]' : heightdesktop
            )}
        >
            {iscolor ? (
                <div className={classNames('absolute w-full h-full', bgcolor)}></div>
            ) : (
                <>
                    <picture className="absolute h-full w-full">
                        {modDesktopXXLImage && (
                            <source srcSet={modDesktopXXLImage} media="(min-width: 1536px)" />
                        )}
                        {modDesktopXLImage && (
                            <source srcSet={modDesktopXLImage} media="(min-width: 1280px)" />
                        )}
                        {modDesktopImage && (
                            <source srcSet={modDesktopImage} media="(min-width: 1024px)" />
                        )}
                        {modTabletImage && (
                            <source srcSet={modTabletImage} media="(min-width: 768px)" />
                        )}
                        {modMobileImage && <source srcSet={modMobileImage} />}
                        <img
                            src={modMobileImage}
                            className={classNames(
                                'object-cover',
                                'h-full',
                                iscathero && 'md:object-top',
                                isfullwidth ? 'w-full' : 'lg:w-screen-xl',
                                'hidden sm:block'
                            )}
                            alt="banner"
                        />
                    </picture>
                    {hasBgOverlay && (
                        <div className="opacity-[.85] bg-white absolute h-full w-full"></div>
                    )}
                </>
            )}
            <Grid
                heighttablet={heighttablet}
                heightdesktop={heightdesktop}
                adjustgridheight={adjustgridheight}
            >
                <div
                    className={classNames(
                        'z-10 h-full',
                        `col-span-${colspanmobile} md:col-span-${colspantablet} lg:col-span-${colspandesktop}`,
                        isleft ? 'lg:col-start-2' : 'lg:col-start-7 md:col-start-5'
                    )}
                >
                    {children}
                </div>
            </Grid>
        </section>
    );
};

export default Hero;
